import LogoDesignInspiration from './components/LogoDesignInspiration';

document.addEventListener('DOMContentLoaded', () => {
    new LogoDesignInspiration();
});



// WEBPACK FOOTER //
// ./js/marketing/logo-design-inspiration.js